var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockedOnCards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "time",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_21026",
    "data-name": "Path 21026",
    d: "M8,14a6,6,0,1,1,6-6A6,6,0,0,1,8,14ZM8,2.857A5.143,5.143,0,1,0,13.143,8,5.143,5.143,0,0,0,8,2.857Z",
    transform: "translate(-2 -2)",
    fill: "#dddfdd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "locked",
    transform: "translate(3.857 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20834",
    "data-name": "Path 20834",
    d: "M9.857,4.571H9.429V3.286a1.286,1.286,0,1,0-2.571,0V4.571H6.429A.429.429,0,0,0,6,5V7.571A.429.429,0,0,0,6.429,8H9.857a.429.429,0,0,0,.429-.429V5A.429.429,0,0,0,9.857,4.571ZM7.286,3.286A.857.857,0,1,1,9,3.286V4.571H7.286Z",
    transform: "translate(-6 -2)",
    fill: "#1e1e1e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockedOnCards);
export default __webpack_public_path__ + "static/media/lockedOnCards.44e7bd3aff121381642b49d39d83e7b1.svg";
export { ForwardRef as ReactComponent };